import Component from '../classes/Component';
import track from '../analytics/amplitude';
import Dropdown from './Dropdown';
import paymentOptions from '../utils/payment-options';

export default class ContactForm extends Component {
	constructor(el) {
		super({
			element: el || '[data-contact-form]',
			elements: {
				form: 'form',
				success: '.c-contact__success',
				countryCode: '[name=code]',
				optionsSelect: '[name=volume]',
				countryInput: '[name=country]',
				analyticSource: '[data-track]',
				countrySearch: '.c-contact__search',
				template: 'template',
				searchbar: '.c-contact__search-bar input',
				dropdownElements: '[data-dropdown]',
				callout: '.c-contact__callout',
				checkboxContainer: '.c-contact__checkbox',
				checkbox: '[type=checkbox]',
				submitButton: '.c-contact__submit',
			},
		});

		this.SUPPORT_SERVICE_API = 'https://paystack.zendesk.com/api/v2';
		this.EMAIL_SERIVCE_API = 'https://paystack-drip-api.glitch.me/bento-event';
		this.ZAPIER_WEBHOOK = 'https://paystack-ats.glitch.me/z-mailer';
		this.searchMenuOpen = false;
		this.handleSubmit();
		this.addEventListeners();
		this.listenForInputChange();

		// eslint-disable-next-line no-new
		this.elements.dropdownElements.forEach(element => {
			// eslint-disable-next-line no-new
			new Dropdown({
				element,
				form: this.elements.form,
			});
		});
	}

	// eslint-disable-next-line class-methods-use-this
	validateURL(urlString) {
		const isValidHttpURL = string => {
			try {
				const url = new URL(string);
				return url.protocol === 'http:' || url.protocol === 'https:';
			} catch (_) {
				return false;
			}
		};

		const validURL = isValidHttpURL(urlString) ? urlString : `https://${urlString}`;
		return `<a href="${validURL}" target="_blank">${urlString}</a>`;
	}

	generateEmailBody(formData) {
		const phone = formData.get('code') + formData.get('phone');
		const comment = formData.get('help');
		const email = formData.get('email');
		const fullName = `${formData.get('fname')} ${formData.get('lname')}`;
		const businessName = formData.get('bname');
		const website = formData.get('website');
		const size = formData.get('size');
		const country = formData.get('country');
		const paymentVolume = formData.get('volume');

		const body = `
			<h3>Terminal Sales Lead</h3>
			<div><b>Name:</b> ${fullName}</div>
			<div><b>Company Name:</b> ${businessName}</div>
			<div><b>Email:</b> ${email}</div>
			${phone ? `<div><b>Phone:</b> <a href="tel:${phone}">${phone}</a></div>` : ''}
			<div><b>Company Website:</b> ${this.validateURL(website)}</div>
			<div><b>Company Size:</b> ${size}</div>
			<div><b>Country:</b> ${country}</div>
			<div><b>Monthly Payment Volume:</b> ${paymentVolume}</div>
			<div><b>Additional Info:</b> ${comment}</div>
		`;
		return body;
	}

	sendFormMessage(formData) {
		const payload = {
			request: {
				requester: {
					name: `${formData.get('fname')} ${formData.get('lname')}`,
					email: formData.get('email'),
				},
				subject: `Terminal Sales Lead: from ${formData.get('bname')}`,
				comment: {
					html_body: this.generateEmailBody(formData),
					public: true,
				},
				custom_fields: [
					{
						// Custom field for Enquiry Support field
						id: 360019692440,
						value: 'inquiry_on_your_paystack_account',
					},
				],
				email_ccs: [{ user_email: 'sales@paystack.com' }],
				tags: ['sales_from_website'],
			},
		};
		return fetch(`${this.SUPPORT_SERVICE_API}/requests.json`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(payload),
		});
	}

	submitViaWebhook(formData) {
		const payload = {
			from: formData.get('email'),
			subject: `Terminal Sales Lead: from ${formData.get('bname')}`,
			name: `${formData.get('fname')} ${formData.get('lname')}`,
			comment: {
				html_body: this.generateEmailBody(formData),
				public: true,
			},
			to: 'sales@paystack.com',
		};
		return fetch(this.ZAPIER_WEBHOOK, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(payload),
		});
	}

	subscribeToEmailService(formData) {
		const phone = formData.get('code') + formData.get('phone');
		const payload = {
			email: formData.get('email'),
			type: 'requestTerminalSupport',
			details: {
				technical_level: formData.get('technical_level') || undefined,
			},
			fields: {
				first_name: formData.get('fname'),
				last_name: formData.get('lname'),
				phone_number: phone || undefined,
				business_name: formData.get('bname'),
				technical_level: formData.get('technical_level') || undefined,
				business_category: formData.get('category'),
				business_size: formData.get('size'),
				opt_in_source: 'terminal landing page',
			},
		};
		return fetch(this.EMAIL_SERIVCE_API, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(payload),
		});
	}

	resetForm() {
		const { form, success } = this.elements;
		form.reset();
		this.element.click();
		form.classList.remove('sent');
		success.classList.remove('sent');
	}

	handleSubmit() {
		const { form, success, submitButton } = this.elements;
		form.addEventListener('submit', e => {
			submitButton.disabled = true;
			e.preventDefault();
			const formData = new FormData(form);

			this.submitViaWebhook(formData)
				.then(() => this.sendFormMessage(formData))
				.then(() => {
					this.track();
					if (formData.get('send-updates')) {
						return this.subscribeToEmailService(formData);
					}
					return Promise.resolve();
				})
				.then(() => {
					form.classList.add('sent');
					success.classList.add('sent');
					submitButton.disabled = false;
					const timeOut = setTimeout(() => {
						this.resetForm();
						clearTimeout(timeOut);
					}, 3500);
				})
				.catch(er => {
					console.error('An has occured', er);
				});
		});
	}

	toggleCallout() {
		const { checkbox, callout } = this.elements;
		if (checkbox.checked) {
			callout.querySelectorAll('input').forEach(input => {
				input.disabled = false;
			});
			callout.classList.add('show');
		} else {
			callout.querySelectorAll('input').forEach(input => {
				input.disabled = true;
			});
			callout.classList.remove('show');
		}
	}

	addEventListeners() {
		const { checkboxContainer } = this.elements;
		checkboxContainer.addEventListener('click', this.toggleCallout.bind(this));
	}

	handleOptionsHTML(options) {
		const { optionsSelect } = this.elements;

		while (optionsSelect.options.length > 2) {
			optionsSelect.remove(2);
		}
		options.forEach(option => {
			const opt = document.createElement('option');
			opt.value = option;
			opt.innerHTML = option;
			optionsSelect.appendChild(opt);
		});
	}

	handlePaymentOptions() {
		const { countryInput } = this.elements;
		const countryNames = Object.keys(paymentOptions);

		if (countryNames.includes(countryInput.value)) {
			const options = paymentOptions[countryInput.value];
			this.handleOptionsHTML(options);
		} else {
			this.handleOptionsHTML(paymentOptions.default);
		}
	}

	listenForInputChange() {
		const { countryInput } = this.elements;

		const observer = new MutationObserver(mutationsList => {
			// eslint-disable-next-line no-restricted-syntax
			for (const mutation of mutationsList) {
				if (mutation.type === 'attributes') {
					this.handlePaymentOptions();
				}
			}
		});
		observer.observe(countryInput, { attributes: true });
	}

	track() {
		const { form, countryInput } = this.elements;
		return track('Submitted Contact Sales Form', {
			Source: form.getAttribute('data-track'),
			Country: countryInput.value,
		});
	}
}
